import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import Image from 'next/image';
import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  position: 'relative',
  alignItems: 'center',
  padding: theme.spacing[12],
  gap: theme.spacing[8],
  backgroundColor: theme.colors.highEmphasisWhite,
  borderRadius: '4px',
  border: `1px solid ${theme.colors.hoverBlack}`,

  [`${theme.mediaBreakpointUp.md}`]: {
    gap: theme.spacing[16],
    flexDirection: 'column',
  },
}));

export const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  padding: 0,
  gap: theme.spacing[8],
  width: '100%',
  height: '100%',
  flex: '1',
  position: 'relative',

  [`${theme.mediaBreakpointUp.md}`]: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const ProductImage = styled(Image)({
  objectFit: 'contain',
  borderRadius: '4px',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  flexShrink: 0,
});

export const Title = styled.div(({ theme }) => ({
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginBottom: 'auto',

  '& span': {
    color: theme.colors.highEmphasisBlack,
  },
}));

export const BadgeContainer = styled.div(({ theme }) => ({
  height: 20,
  display: 'flex',
  marginTop: theme.spacing[4],
}));

export const CostContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[4],
  marginBottom: theme.spacing[4],
}));

export const PriceContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[4],
  flex: 1,
}));

export const CurrentPrice = styled.div(({ theme }) => ({
  '& span': {
    color: theme.colors.highEmphasisBlack,
  },
}));

export const OriginalPrice = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})(() => ({
  color: '#9E9E9E',
  textDecoration: 'line-through',
}));
